import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Criterium, CriteriumTable, CriteriumSkeleton } from '@hydra/common/criterium';
import { Icon, Translate, SafeAnchor } from '@hydra/common/components';
import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  logo: {
    display: 'inline-block',
    marginRight: theme.spacing(1),
    width: '20px',
    height: '20px'
  },
  table: {
    marginBottom: theme.spacing(1)
  },
  profileCol: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const ALLOWED_PROFILES = [
  'facebook',
  'twitter',
  'instagram',
  'linkedIn',
  'crunchbase',
  'youTube',
  'pinterest',
  'reddit',
  'tumblr',
  'soundCloud',
  'vimeo',
  'yelp',
  'foursquare',
  'mySpace',
  'github',
  'etsy',
  'discord',
  'slack',
  'huggingFace',
  'tikTok',
  'medium'
];

export const DiscoveredSocialProfiles = ({ criterium }) => {
  const classes = useStyles();
  const { variant } = useReviewContext();

  const { data, url } = criterium;

  const rows = ALLOWED_PROFILES.reduce((result, profile) => {
    if (data[profile] && data[profile].length > 0) {
      const url = data[profile][0].url;
      result.push([
        <div key={profile} className={classes.profileCol}>
          <Icon className={classes.logo} type={`${profile.toLowerCase()}`} />
          <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank' key={url}>{url}</SafeAnchor>
        </div>
      ]);
    }
    return result;
  }, []);

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {
        rows.length
          ? (
            <>
              {
                variant === 'nocrit'
                  ? <CriteriumSkeleton width='70%' />
                  : <Translate content='discovered_social_profiles_ok' component='p' />
              }
              <CriteriumTable
                className={classes.table}
                rows={rows}
                thinHead
                striped
                nowrap
              />
            </>
            )
          : (variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='discovered_social_profiles_ko' component='p' />)
      }

    </Criterium>
  );
};

export default React.memo(DiscoveredSocialProfiles);
